module.exports = __webpack_public_path__ + "img/weather41.0837bc32.png";